/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': '이 계정은 등록되지 않았습니다. 먼저 가서 등록한 후 로그인하십시오.',
    'no_zone_code': '(국가 번호 없음)',
    '授权校验失败，请刷新页面并重试。': 'Authorization verification failed. Please refresh the page and try again.',
    'onlineService': 'Online service',
    'standardExpress': '스탠다드 익스프레스',
    'economyExpress': '이코노미 익스프레스',
    'eParcel': 'E-파슬',
    'overseasFulfilment': '해외 풀필먼트',
    'warehouse': '해외 창고',
    'pleaseAgreePolicy': 'Please read and agree to the Privacy Policy',
    'pleaseAgreeToScan': '오른쪽 약관을 먼저 읽고 동의해 주세요',
    'heavyFreight': '국제 대형화물',
    '验证码接收方式': '인증 코드 수신 방법',
    'cancelTips': '주의 사항을 모두 확인하였으며, 이에 동의합니다.',
    'confirmCancel': '탈퇴 확인',
    'verificationCodeError': '인증 코드 오류, 인증 코드를 다시 가져오십시오!',
    'clickGoDirectly': '(클릭하여 바로 가기)',
    'repeatTips': '계정 중복 문제가 있으면 <span class="mode">로그인 방법 </span>을 선택한 후 로그인하여 {count}초 후 자동 점프',
    'repeatTips1': '휴대폰 번호에 중복 문제가 있습니다. <span class="mode">지역번호 </span>을 선택한 후 로그인하여 {count}초 후 자동으로 이동하십시오.',
    'goOldLogin': '레거시 로그인',
    'goNewLogin': '새 로그인',
    'siteTips': '더 나은 시스템 경험을 위해 다른 국가 또는 지역으로 전환하도록 선택할 수 있습니다.',
    'siteGo': '이동',
    'loginLoading': '자동으로 새 시스템에서 로그인 중입니다. 잠시만 기다려 주세요.',
    'sfExpress': '순풍속운판권소유 광동ICP비08034243호',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': '국제 인증 서비스 센터',
    'jumpError': '점프 주소가 합법적이지 않음',
    'tips': '안내',
    'tips1': '안내',
    'confirm': '확인',
    'agreeAndContinue': '개인 정보 보호 정책을 읽고 동의합니다.',
    'agreeService': '서비스 약관을 읽고 동의합니다.',
    'agreeUserAgreement': '사용자 계약을 읽고 동의합니다.',
    'define': '확인',
    'cancel': '취소',
    'yes': '네',
    'no': '아니오',
    'sendAgain': '재전송',
    'second': '초',
    'iknow': '동의',
    'country': '국가 / 지역',
    'tel': '휴대폰 번호',
    'email': '이메일',
    'telNumber': '휴대폰 번호: ',
    'verifyCode': '인증번호',
    'sendVerificationCode': '인증 코드 보내기',
    'next': '다음',
    'prev': '이전',
    'finished': '완료',
    'back': '뒤로',
    'backLogin': '로그인으로 돌아가기',
    'home': '인터네셔널 웹사이트',
    'home_os': 'ABX Express',
    'inquiry': '검색',
    'add': '추가',
    'edit': '편집',
    'del': '삭제',
    'batchDel': '대량 삭제',
    'operating': '작업',
    'clearInfo': '삭제',
    'excelUpload': '엑셀 업로드',
    'serialNumber': '순서',
    'save': '저장',
    'leastOne': '삭제 할 부분을 선택하세요',
    'uploadFile': '업로드 파일',
    'downloadExcel': '엑셀 템플릿 다운로드',
    'pleaseInput': '내용을 입력하세요',
    'pleaseSelect': '선택하세요',
    'isDel': '선택 한 내용을 정말 삭제하시겠습니까?',
    'agree': '동의',
    'disagree': '반대',
    'uploadTotal': '전체 업로드',
    'uploadSuccess': '업로드 성공',
    'uploadFail': '업로드 실패',
    'checkAll': '전체 선택',
    'cancelContent': "이 계정을 [{cancelTime}]에 삭제 요청하셨습니다. 15일 이내에 다.시 로그인하면 '계정 삭제'가 취소됩니다. 계속 로그인하시겠습니까?",
    'ok': '좋아',
    'autoTip': '권한 검토 중입니다. 기다려 주십시오...',
    'feedback': '기능 피드백/의견',
    'scanCode': '스캔 로그인',
    'useWxScan': '위챗으로 한번 훑어보다.',
    'useWhatsAppScan': 'WhatsApp으로 스캔 사용',
    'otherLoginWays': '기타 로그인 방법',
    'scanSuccessfully': '스캔 성공',
    'confirmOnPhone': '핸드폰에서 확인하세요.',
    'refreshQR': '새로 고침을 클릭하십시오.',
    'consult': '협력 컨설팅',
    'please_select_correct_phone': '정확한 핸드폰 지역 번호를 선택하세요.',
    '国际标快': 'Standard Express',
    '国际特惠': 'Economy Express',
    '顺丰集运': 'SFBUY',
    '国际电商专递': 'E-Commerce Express',
    '国际小包': 'E-Parcel',
    '海外仓': 'Overseas Fulfilment/Warehouse',
    '顺丰国际产品导航': 'Product Navigation'
  },
  'channel': {
    'gls': 'gls',
    'gls_tooltip': '툴팁'
  },
  'login': {
    'selectLoginType': '로그 인 방식 선택',
    'personal': '개인 로그인',
    'enterprise': '기업 로그인',
    'tel': '휴대폰 번호',
    'password': '비밀번호',
    'verificationCodeLogin': '인증번호로 로그인',
    'verificationCode': '인증 코드',
    'obtainVerificationCode': '인증번호 요청',
    'passwordLogin': '비밀번호 등록',
    'rememberPSD': '아이디 저장',
    'rememberTips': 'PC방 등 공용으로 사용되는 PC에는 선택 하지 마십시오.',
    'forgetPSD': '비밀번호 찾기',
    'loginAgree': '모두 확인하였으며 이에 동의합니다',
    'agreeTips': '개인정보정책',
    'userAgreement': '사용자 프로토콜',
    'login': '로그인',
    'username': '아이디',
    'email': '이메일',
    'phoneLogin': '휴대폰 번호로 로그인',
    'usernameLogin': '아이디 등록',
    'emailLogin': '이메일로 로그인',
    'usernameOrEmailLogin': '아이디/ 이메일 로그인',
    'registerNow': '가입',
    'pleaseInput': '',
    'and': '&',
    'sfbuy_privacy': '해매풍운서비스협의',
    'sfbuy_title': 'SFBuy',
    'aboutUs': '우리에 대해',
    'serviceGuide': '신입 가이드',
    'helpCenter': '도움말 센터',
    'serviceAndPrice': '서비스 및 가격',
    'onlineCSR': '온라인 고객 서비스',
    'copyright': "Copyright ©2023 순풍속운 판권 소유'"
  },
  'register': {
    'personal': '개인 고객 가입',
    'enterprise': '기업 고객 가입',
    'tel': '휴대폰 번호',
    'telVerificationCode': '휴대폰 인증번호',
    'email': '이메일',
    'emailVerificationCode': '비밀번호 확인',
    'sendVerificationCode': '인증 코드 보내기',
    'password': '비밀번호',
    'passwordAgain': '비밀번호 확인',
    'agree': '확인하였으며 동의합니다',
    'termsOfService': '서비스약관',
    'SFBuyService': 'SFBUY 서비스 계약서',
    'and': '&',
    'privacyPolicy': '개인정보정책',
    'registerNow': '가입',
    'haveUserName': '계정이 이미 있습니까?',
    'loginNow': '즉시 로그인',
    'toEmail': '이메일 가입',
    'toTel': '휴대폰 번호 가입',
    'invitationCode': '추천인 코드',
    'timeCount': '(나머지 {count}s, 끝까지 읽으십시오.)',
    'readBottom': '(끝까지 읽으십시오.)',
    'isFinshRead': '약관 정보를 읽고 동의하십시오.'
  },
  'resetPassword': {
    'resetTel': '휴대폰 번호 재설정',
    'resetEmail': '이메일 재설정',
    'tel': '휴대폰 번호',
    'telVerificationCode': '휴대폰 인증번호',
    'email': '이메일',
    'emailVerificationCode': '이메일 인증번호',
    'sendVerificationCode': '인증 코드 보내기',
    'newPassword': '새로운 비밀번호',
    'confirmNewPassword': '비밀번호 확인',
    'resetPassword': '비밀번호 재설정',
    'back': '뒤로',
    'login': '로그인',
    'register': '회원가입'
  },
  'modifyPassword': {
    'changePassword': '비밀번호 변경',
    'old': '현재 비밀번호',
    'new': '새 암호',
    'confirm': '비밀번호 확인'
  },
  'cookies': {
    'tip1': '당사 웹 사이트는 Cookie 를 사용하여 사용자 경험 및 분석을 최적화합니다. 당사는 귀사의 정보를 분석 파트너와 공유할 수 있습니다.',
    'tip2': 'Cookie 정책',
    'tip3': '더 많은 정보를 제공합니다. 설정을 변경하려면 클릭하십시오',
    'tip4': '여기',
    'tip5': '동의를 클릭하면 사용자의 기본 설정에 따라 쿠키 사용에 동의하는 것으로 간주합니다.',
    'disAgree': '거절',
    'cookieSet': 'Cookie 설정',
    'preference': '선호',
    'optimisation': '최적화',
    'analytics': '분석',
    'neddCheck': '선호하는 종류를 먼저 선택 해 주세요',
    'cookie': 'Cookie 정책',
    'agree': '동의',
    'preferenceCenter': '선호 중심'
  },
  'slideCircus': {
    'title': '아래 퍼즐을 완성하여 인증 해 주세요',
    'change': '변경',
    'right': '오른쪽으로 드래그하여 퍼즐을 완성하십시오',
    'pass': '인증 완료',
    'verifyText': '인증 버튼을 클릭 해 주십시오',
    'verifying': '퍼즐 확인 중...',
    'loading': '사진 로딩 중…'
  },
  'message': {
    'slideError': 'Slider service request failed',
    'selectTerms': '약관 정보를 확인하고 체크하십시오',
    'verifyPass': '확인 버튼을 클릭하십시오.',
    'registerSuccess': '회원가입이 완료 되었습니다.',
    'sendTips0': '발송완료',
    'resetPasswordTips0': '비밀번호가 재 설정 되었습니다.',
    'loginTips0': '로그인 성공',
    'loginTips1': '로그인 성공을 성공하였습니다. 계정이 활성화 되었습니다.',
    'modifiedTips0': '수정이 완료되었습니다.',
    'switchLanguage': '언어 선택이 변경되었습니다.',
    'switchSite': '국가 전환 성공',
    'changeTel': '휴대폰 번호가 변경 되었습니다.',
    'ChangeEmail': '축하합니다. 메일박스 수정 성공, 다시 로그인하세요!',
    'cancelSuccess': '이 계정은 해지되었습니다.',
    'imgType': '사진을 재 선택 부탁 드립니다. 사진은 JPG, PNG 양식만 업로드 가능합니다.',
    'imgSize': '사진을 재 선택해 주세요.  사진크기는 3MB 초과 불가합니다.',
    'submitSuccess': '제출 성공',
    'setSuccess': '설정 성공',
    'delSuccess': '삭제 성공',
    'addSuccess': '추가 성공',
    'fileType': '파일을 재 선택 부탁 드립니다.  파일은 xls 또는 xlsx 양식만 가능합니다.',
    'fileSize': '파일을 다시 선택하십시오. 파일 크기는 15MB를 초과할 수 없습니다!',
    'delError': '삭제를 실패 하였습니다. 잠시 후 다.시 이용 부탁 드립니다.',
    'uploadFile': '파일 업로드 부탁 드립니다',
    'uploadFileSuccess': '업로드 성공',
    'selectedOne': '통관 자료 또는 생년월일 중 하나를 입력하십시오',
    'imgTips1': '{imgType} 양식의 사진 업로드 해 주십시오',
    'imgTips2': '사진은 3MB를 초과할 수 없습니다.',
    'imgTips3': '사진은 3MB를 초과할 수 없습니다.',
    'imgTips4': 'PDF 파일 미리보기는 지원되지 않습니다.',
    'checkProduct': '제품을 선택하십시오.',
    'clauseAgree': '전자 운송장 계약 조항에 동의하십시오.',
    'estimatedCost': '추가 서비스 양식에 예상 요금을 입력하십시오.',
    'cardCode': '부가 가치 서비스 표에 예상 COD용 카드 번호를 입력하십시오',
    'threeTips': '발송 화물 정보가 정확하지 않습니다. 다시 확인 부탁드립니다.',
    'fourTips': '오더 정보가 정확하지 않습니다. 다시 확인 부탁 드립니다.',
    'noNeedUpload': '신분증을 업로드 할 필요 없습니다.',
    'phoneOrFixAtLeastOne': '핸드폰 번호, 고정 전화는 적어도 하나 기입해 주십시오',
    'customerOrderNo': '고객 주문 번호를 입력하십시오.',
    'mas_003038': '로그인 계정에 이상이 생겼습니다. 페이지를 새로 고쳐서 주문하십시오.',
    'mas_003038_HTM': '로그인 (휴대폰 번호) 에 이상이 발생했습니다. 페이지를 새로 고치고 주문을 시도하십시오.',
    'mas_003035': '귀하의 계정이 이미 등록되었으니 IUOP에서 직접 국제 주문서에 로그인하십시오.',
    'mas_auth_failed': '감권 실패'
  },
  'verify': {
    'selectAreaCode': '국가 / 지역 번호를 선택하십시오.',
    'telTips': '휴대폰 번호를 입력하십시오.',
    'telError': '정확한 휴대폰 번호를 입력하십시오.',
    'companyNameTrue': '정확한 회사 이름을 입력하십시오.',
    'fixMobileCode': '고정 전화 지역 번호를 선택하십시오.',
    'fixMobileNumber': '전화 번호를 입력하십시오.',
    'fixMobileNumberReg': '정확한 전화 번호를 입력하십시오.',
    'mobileVerificationCode': '인증코드를 입력하십시오.',
    'emailAddress': '이메일 주소를 입력하십시오',
    'emailTips': '이메일 주소가 올바르지 않습니다.',
    'emailVerificationCode': '이메일 인증번호를 입력하십시오',
    'password': '비밀번호를 입력해 주십시오.',
    'passwordError': '암호는 8-20비트이며 대소문자, 숫자 및 기호 2개 이상의 조합만 지원',
    'passwordAgain': '비밀번호를 다시 입력해 주십시오.',
    'passwordNotSame': '입력한 암호가 일치하지 않습니다. 다시 입력하십시오.',
    'usernameTips': '아이디를 입력하십시오.',
    'usernameEmailTips': '아이디/이메일을 입력하십시오.',
    'telEmailTips': '휴대폰 번호 (국가 번호 없음)/ 메일박스 입력',
    'fixTelEmailTips': '정확한 핸드폰 번호 (국가 번호 없음)/ 메일박스를 입력하세요',
    'selectTerms': '약관 정보를 확인하고 체크하십시오',
    'accountName': '알파벳 으로 시작 하여 알파벳,숫자 및 밑줄 을 포함 하 는 6-20 자 를 지원 합 니 다',
    'verifyType': '인증 방식을 선택 하십시오.',
    'verifyCode': '認証コードを入力してください',
    'lastNameRequired': '성 입력은 필수 입니다.',
    'firstNameRequired': '이름 입력은 필수 입니다.',
    'genderRequired': '성별 입력은 필수 입니다.',
    'birthdayRequired': '생년월일 입력은 필수 입니다.',
    'certTypeRequired': '신분증 타입 입력은 필수 입니다.',
    'certNoRequired': '신분증 번호 입력은 필수 입니다.',
    'certExpireDateRequired': '신분증 유효기간 입력은 필수 입니다.',
    'notSupTips': '숫자 및 특수 문자는 지원되지 않습니다.',
    'certImage': '신분증 업로드 후 제출 하십시오',
    'commodityName': '발송 품명을 입력하십시오',
    'quantity': '수량을 입력하십시오',
    'unit': '단위를 입력하십시오',
    'unitPrice': '단가를 입력하십시오',
    'placeOfOrigin': '원산지를 입력하십시오',
    'over0': '0보다 큰 숫자를 입력하십시오',
    'decimal3': '소수점 뒤 3자리만 지원됩니다.',
    'decimal6': '소수점 뒤 6자리만 지원됩니다.',
    'decimal10': '소수점 뒤 10자리만 지원됩니다.',
    'productRecordNo': '정확한 검역 등록 번호를 입력하십시오.',
    'hsCode': '정확한 HS 코드를 입력하십시오.',
    'productCustomsNo': '정확한 EORI No를 입력하십시오.',
    'contact': '이름을 입력하십시오',
    'companyName': '회사명을 입력하십시오',
    'country': '국가/지역을 선택하십시오',
    'regionFirst': '시 / 도를 선택하십시오.',
    'roadName': '도로명 입력하십시오',
    'buildingNumber': '건물 번호를 입력하십시오',
    'addressDetail': '주소를 입력하십시오',
    'addressDetailTrue': '정확한 주소를 입력하십시오',
    'postalCode': '우편번호를 입력하십시오.',
    'phoneNumber': '휴대폰 번호를 입력하십시오.',
    'numberDecimal': '숫자를 입력하십시오',
    'bangmecho': '도로명을 입력하십시오',
    'shippingType': '발송인 타입을 선택하십시오',
    'clearanceInfo': '신분증 타입을 선택하십시오',
    'idNumber': '신분증 번호를 입력하십시오',
    'idNumberIsTrue': '정확한 신분증 번호를 입력하십시오',
    'contactCn': '정확한 중문명을 입력하십시오',
    'receiveType': '수취입 타입을 선택하십시오',
    'imgNumber': '최소 {number}장 이상 사진을 업로드 하십시오',
    'papersTime': '신분증 유효기간을 선택하십시오',
    'declaredCurrency': '화폐 종류를 선택하십시오',
    'requred': '이 필드 입력은 필수 입니다.',
    'parcelTotalWeight': '총 중량을 입력하십시오',
    'contentMaxLength18': '1~18자 이내로 입력 하십시오',
    'contentIntOrFloatMaxLength': '최대 12자리 정수 및 10자리 소수점까지만 지원합니다.',
    'atLeastSelectTip': '하나 이상 선택하십시오',
    'invitationCode': '정확한 인증코드를 입력하십시오',
    'characterLength': '{length}자를 초과 할 수 없습니다.',
    'pickUpTime': '방문 픽업 예약 시간을 선택하십시오',
    'onlyNumberAndLetter': '숫자와 영문만 지원됩니다.',
    'serviceFee': '추가 서비스 예상 요금은 최대 12비트 정수, 2비트 소수점 지원',
    'methoedCode': '최대 20자리 숫자만 지원됩니다.',
    'contentInt14OrFloat2MaxLength': '최대 14자리 정수 및 2자리 소수점까지만 지원됩니다.',
    'contentInt10OrFloat6MaxLength': '최대 10자리 정수 및 6자리 소수점까지만 지원됩니다.',
    'contentInt18OrFloat6MaxLength': '최대 18자리 정수 및 6자리 소수점까지만 지원됩니다.',
    'timeZoneCode': '시간대를 선택하십시오',
    'contentInt14OrFloat1MaxLength': '최대 14자리 정수 및 1자리 소수점까지만 지원됩니다.',
    'contentInt15OrFloat5MaxLength': '최대 15자리 정수 및 5자리 소수점까지만 지원됩니다.'
  },
  'placeholder': {
    'countryCode': '국가 / 지역 번호를 선택하십시오.',
    'telCode': '지역 코드',
    'phoneCode': '핸드폰 번호를 입력하세요.',
    'mobileVerificationCode': '인증코드를 입력하십시오.',
    'verificationCode': '인증 코드를 입력하세요',
    'emailAddress': '이메일 주소를 입력하십시오',
    'emailVerificationCode': '이메일 인증번호',
    'password': '비밀번호를 입력해 주십시오.',
    'checkPassword': '암호를 다시 입력하십시오.',
    'enter': '입력하십시오.',
    'username': '아이디로 로그인',
    'cardType': '신분증 타입을 선택하십시오 ',
    'uploadCard': '신분증 정보와 일치해야 합니다.',
    'uploadCardId': '유효한  신분증 번호를 입력하십시오.',
    'passwordError': '암호는 8-20비트이며 대소문자, 숫자 및 기호 3개 이상의 조합만 지원',
    'passwordAgain': '비밀번호를 다시 입력해 주십시오.',
    'verifyType': '인증 방식을 선택 하십시오.',
    'newEmail': '자주 사용하는 이메일을 입력하십시오.',
    'addressBook': '성명/회사명을 입력하여 검색하십시오.',
    'goodsWarehouse': '발송 화물명/세관코드를 입력하여 검색하십시오.',
    'clearanceWaybill': '12비트 디지털 운송장 번호 또는 \\SF\\로 시작하는 15비트 운송장 번호를 입력하십시오.',
    'parcelTotalLength': '길이(length)를 입력하십시오',
    'parcelTotalWidth': '폭(width)을 입력하십시오',
    'parcelTotalHeight': '높이(height)를 입력하십시오',
    'senderReason': '발송 목적을 선택하십시오',
    'tradeCondition': '무역 조건을 선택하십시오',
    'senderReasonContent': '비상업적 (non-commercial) 화물 발송 목적을 입력하십시오.',
    'businessRemark': '인보이스 remark란 내용을 입력하십시오',
    'pickupAppointTime': '날짜 및 시간 선택 (픽업 시간은 예약 후 3시간 이내)',
    'remarkText': '텍스트를 입력하십시오.',
    'payMethod': '운임 지불 방식을 선택하십시오',
    'payMonthCard': 'ABX 어카운트 번호를 입력하십시오',
    'taxPayMethod': '세금 지불 방식을 선택하십시오',
    'taxPayMonthCard': '세금 결제 어카운트 번호를 입력하십시오',
    'serviceFee': '예상 비용을 입력하십시오',
    'feeCard': 'COD 카드번호를 입력하십시오',
    'invitationCode': '가입 인증코드를 입력하십시오',
    'willBay': '운송장 번호를 입력하십시오',
    'senderCountry': '발송인 국가를 선택하십시오',
    'receiverCountry': '수취인 국가를 선택하십시오',
    'receiverContact': '수취인 이름을 입력하십시오',
    'orderStatus': '오더 상태를 선택하십시오',
    'startTime': '시작일자',
    'to': '~',
    'endTime': '종료일자',
    'timeZoneCode': '시간대를 선택하십시오'
  },
  'tagsView': {
    'refresh': '새로 고침',
    'close': '닫기',
    'closeOthers': '닫기 기타',
    'closeAll': '모두 닫기'
  },
  'exit': {
    'title': '로그아웃',
    'message': '정말 로그아웃 하시겠습니까?',
    'success': '로그아웃 성공',
    'cancel': '로그아웃 취소',
    'close': '삭제 성공'
  },
  'notFind': {
    'oops': '404',
    'info': '죄송합니다. 요청하신 페이지를 찾을 수 없습니다.',
    'backHome': '홈으로 돌아가기'
  },
  'settings': {
    'title': 'ABX Order Platform'
  },
  'role': {
    'admin': '관리자',
    'user': '고객'
  },
  'route': {
    'Login': '로그인',
    '顺丰国际产品导航': 'Product Navigation',
    'Register': '등록',
    'ResetPassword': '비밀번호 찾기',
    'UserCenter': '프로필',
    'MyInfomation': '내 정보',
    'AccountInfomation': '어카운트 정보',
    'BaseInfomation': '기본 정보',
    'AccountSecurity': 'ABX Order Platform',
    'firstname': 'first name',
    'lastname': 'last name',
    'SettingRealName': 'Set First name&Last name	',
    'SettingRealNameDesc': 'Set personal name information as an account attribute that can be edited multiple times.',
    'ProtocolManage': '서명 관리',
    'BindingEmail': '이메일 연동',
    'BindingPhone': '휴대폰 연동',
    'CancelAccount': '계정 삭제',
    'ChangeEmail': '이메일 변경',
    'ChangePassword': '암호 수정',
    'ChangePhone': '연락처 변경',
    'Name': '아이디 설정',
    'ToMail': '발송',
    'MailProduct': '이용 서비스',
    'AddressBook': '주소 리스트',
    'GoodsWarehouse': '물품 창고',
    'Order': '오더 관리',
    'OrderIndex': '오더 목록',
    'OrderAdd': '개별 오더',
    'Clearance': '통관 자료',
    'UploadPhotoid': '신분증 업로드',
    'EditOrder': '주문 편집',
    'permission': '권한 관리',
    'permission_system': '시스템 관리',
    'permission_role': '역할 관리',
    'permission_resource': '자원 권한',
    'permission_user': '사용자 관리'
  },
  'button': {
    'sumbit': '제출'
  },
  'accountInfo': {
    'username': '아이디',
    'firstname': '이름',
    'lastname': '성',
    'sex': '성별',
    'man': '남',
    'woman': '여',
    'telNumber': '휴대폰 번호:',
    'telNumberNot': '귀하의 계정과 휴대폰 번호가 연동 되지 않았습니다.',
    'email': '이메일',
    'emailNot': '귀하의 계정과 이메일 주소가 연동 되지 않았습니다.',
    'binding': '연동',
    'changeTel': '연락처 변경',
    'changeEmail': '축하합니다. 메일박스 수정 성공, 다시 로그인하세요!',
    'validated': '인증 완료',
    'autoGeneration': '자동 생성',
    'usernameTips': 'ID 설정 후 변경 불가',
    'birthday': '생년월일: ',
    'birthday1': '생년월일: ',
    'autoCreate': '자동 생성'
  },
  'baseInfo': {
    'cardType': '신분증 타입: ',
    'firstname': '이름',
    'lastname': '성',
    'cardId': '신분증 번호: ',
    'cardTime': '신분증 유효기간: ',
    'cardImg': '증명서 사진: ',
    'cardLangTime': '평생 유효',
    'uploadImg': '사진 업로드',
    'titleTips': '주의사항: 국제 발송건은 실명제를 실시하고 있어 통관을 위해 신분증이 필요하고 신분증에는 통관 전용 직인이 날인 될 예정입니다.SF는 고객님의 정보 보호에 노력하고 있습니다.',
    'dialogTitle': '안내',
    'dialogTips': '업로드 한 신분증은 선명해야 하고 빛 반사가 없어야 합니다.흐릿하거나 어두울 경우 인증이 실패 할 수 있습니다.',
    'cardUp': '신분증 앞면',
    'cardDown': '신분증 뒷면'
  },
  'emailLink': {
    'tips': '비밀번호를 설정 해 주십시오',
    'setPassword': '비밀번호 설정',
    'success': '계정 활성화 성공'
  },
  'accountSecurity': {
    'ChangePassword': '암호 수정',
    'ChangePasswordDesc': '비밀번호를 잃어버린 경우 인증 후 비밀번호를 변경하시기 바랍니다.',
    'BindingPhone': '휴대폰 연동',
    'BindingPhoneDesc': '연동 된 휴대폰 번호로 로그인, 비밀번호 찾기, 오더등의 서비스 이용이 가능합니다.',
    'BindingEmail': '이메일 연동',
    'BindingEmailDesc': '연동 된 휴대폰 번호로 로그인, 비밀번호 찾기, 오더등의 서비스 이용이 가능합니다.',
    'SettingName': '사용자 이름 설정',
    'SettingNameDesc': '아이디로 로그인 계정을 설정 할 수 있으나 설정 후 변경이 불가합니다.',
    'immediatelySet': '설정',
    'alreadySet': '이미 설정 됨',
    'settingComplete': '설정 완료',
    'alreadyBinding': '이미 연동 됨',
    'userName': '아이디',
    'userNameLogin': '아이디를 설정 후에는 변경이 불가 합니다.',
    'selfCreate': '자동 생성',
    'stopEdit': '아이디를 설정 후에는 변경이 불가 합니다.',
    'setOk': '설정 완료',
    'cancelAccount': '계정 삭제',
    'cancelAccountTips': '계정을 삭제하면 저장 된 데이터도 모두 삭제되니 신중히 결정 부탁 드립니다.',
    'toCancel': '바로 삭제',
    'cancelToKnow': '계정 로그아웃 프로토콜',
    'cancelDesc1': '1. 본 계정은 ABX International 플랫폼의 통합 계정입니다.본 계정을 삭제하면 삭제된 계정은 ABX International 과 관련 된 모든 플랫폼에서 사용 및 복구 될 수 없습니다. 삭제 전 모든 정보와 데이터를 백업하십시오.',
    'cancelDesc2': '2. 계정 삭제 신정은 고객님의 모든 회원 권리 및 가상자산 (멤버십 포인트, 회원등급, 쿠폰 등을 포함하되 국한되지 않음)을 포기하는 것을 의미합니다.',
    'cancelDesc3': '3. 계정 삭제 후에는 본 계정을 다시 로그인하거나 사용할 수 없으며, 계정 및 계정과 관련된 어떤 내용이나 정보도 찾을 수 없습니다. 아이디, 프로필등을 포함하되 국한되지 않습니다.  (운송장 정보는 개인 보호 정책에 따라 보관 기한이 제한되며 ABX 웹사이트에서 운송장 정보를 조회 있음)',
    'cancelDesc4': '4. 어카운트를 개설한 고객님의 경우, 계정을 삭제하면 본 계정과 연동되어 있던 어카운트의 연동이 해지됩니다. 어카운트를 계속 사용하기 위해서는 새로운 계정을 연동해야 합니다.',
    'cancelDesc5': '5. 본 계정을 삭제한다고 하여 계정 삭제 전의 부채가 면제되거나 경감되지는 않습니다.',
    'cancelDesc6': '6. 본 계정 삭제 신청은 15일 이내에 취소할 수 있으며 삭제 신청일로부터 15일 이내 재접속하여 삭제 취소 신청을 할 수 있습니다. ',
    'cancelAgree': '계정 로그아웃 프로토콜을 읽고 동의했습니다.	',
    'cancelTitle': '계정 로그아웃',
    'cancelConfirm': '계정을 정말 삭제하시겠습니까?',
    'cancelTips': '주의 사항을 모두 확인하였으며, 이에 동의합니다.',
    'goBinding': '연동',
    'changeBinding': '연동 변경',
    'auth': '인증 완료',
    'finish': '변경 완료',
    'binding': '연동 완료',
    'verifyType': '인증 방법',
    'ChangePhone': '연락처 변경',
    'ChangeEmail': '이메일 변경',
    'tips1': '비밀 번호 변경이 완료되었습니다.',
    'tips2': '휴대폰 번호 변경이 완료되었습니다.',
    'tips3': '이메일 변경이 완료되었습니다.',
    'tips4': '휴대폰 연동이 완료되었습니다.',
    'tips5': '이메일 연동이 완료되었습니다.',
    'tips6': '아이디 설정이 완료되었습니다.'
  },
  'accountConflict': {
    'title': '계정 정보 확인',
    'desc1': '안녕하세요!',
    'desc2': '이메일 주소/ 휴대폰 번호가 당사의 여러 시스템에 계정으로 등록된 것을 확인하였습니다. </br> 원활한 시스템 사용을 위해 하나의 계정을 선택하여 사용하시기 바랍니다.',
    'desc3': '확인"을 클릭하면 이메일 주소 또는 휴대전화로 패스워드 변경 링크가 발송됩니다. 안내에 따라 진행 부탁 드립니다.',
    'loginName': '로그인 이름',
    'phone': '휴대폰 번호',
    'registerSys': '가입 시스템',
    'registerTime': '가입 시간',
    'newRegister': '새로운 가입',
    'infoVer': '정보 인증',
    'inforVerSelect': '인증 방법을 선택 하십시오.',
    'selectOne': '하나의 계정을 선택하여 로그인 하십시오.',
    'IBS': 'Order and Shipment Management System',
    'ICAS': 'International Customer Account System',
    'IUOP': '국제 통합 주문 플랫폼',
    'IBSE': 'International Business System Export',
    'PMS': 'International Business System Import',
    'IBSI': '국제 상가 물류 수입',
    'SFBUY': 'ABX BUY',
    'POP': 'Partner Open Platform',
    'SFGOAPP': 'ABX GO',
    'IFTP': 'International Freight Transportation Platform',
    'OFTP': '해외 화물 운송 플랫폼'
  },
  'permission': {
    'reset': '재설정',
    'enable': '활성화',
    'disable': '비활성화',
    'delete': '삭제',
    'deleteBatch': '대량 삭제',
    'remark': 'Remark',
    'sort': '정렬',
    'confirm': '확인',
    'cancel': '취소',
    'operation': '작업',
    'modify': '수정',
    'select': '선택하십시오.',
    'input': '사용자 이름 또는 번호를 입력하십시오.',
    'query': '질의',
    'edit': '편집',
    'required_rule': '데이터는 비워둘 수 없습니다.',
    'success': '작업 성공',
    'fail': '작업 실패',
    'length_rule': '{min} - {max} 자',
    'deleteTip1': '{name} 아래에 있는 모든 서브시스템을 비활성화하십시오.',
    'deleteTis': '이름이 "{name}"인 데이터 항목을 삭제하시겠습니까?',
    'deleteChildTis': '동시에 이 시스템의 모든 시스템이 삭제됩니다.',
    'tis': '힌트',
    'deleteBatchTis': '선택한 {num} 개의 데이터를 삭제하시겠습니까?',
    'enableTis': '{statusName} 선택한 {num} 개의 데이터를 확인하시겠습니까?',
    'msgError': '운영 데이터 오류',
    'codeCheckRule': '대소문자, 숫자, "_"또는 "-"허용',
    'checkMinCharacter': '{min} 자 이상을 입력하십시오.',
    'roleType_0': '자체 제작 역할',
    'roleType_1': '시스템 관리자',
    'bindResource': '리소스 바인딩',
    'roleList': '역할 목록',
    'roleAdd': '새 역할',
    'roleEdit': '역할 편집',
    'roleConfig': '역할 구성',
    'childSystemName': '서브시스템 이름',
    'roleNo': '역할 번호',
    'roleName': '역할 이름',
    'roleDescribe': '역할 설명',
    'isSystem': '소속 시스템',
    'roleType': '역할 유형',
    'userStatus_0': '비활성화',
    'userStatus_1': '활성화됨',
    'userStatus_2': '로그아웃 전',
    'userStatus_3': '로그아웃됨',
    'userStatus_4': '비활성화',
    'userStatus_5': '잠금',
    'userRoleEdit': '역할 보기 / 편집',
    'userList': '사용자 목록',
    'regtime': '등록 시간',
    'userCode': '사용자 번호',
    'area': '소속 지역',
    'nickName': '닉네임',
    'sourceSystem': '소스 시스템',
    'userStatus': '상태',
    'systemList': '시스템 목록',
    'systemAdd': '새 시스템',
    'systemModify': '시스템 수정',
    'systemName': '시스템 이름',
    'systemType': '시스템 유형',
    'systemType_0': '마스터 데이터',
    'systemType_1': '비즈니스 시스템',
    'systemCode': '시스템 인코딩',
    'systemStatus': '시스템 상태',
    'systemStatus_0': '활성화',
    'systemStatus_1': '비활성화',
    'systemAddChildren': '새 서브시스템',
    'systemSuperior': '상위 시스템',
    'resourceList': '리소스 목록',
    'resourceAdd': '신규 리소스',
    'resourceModify': '자원 수정',
    'resourceName': '자원 이름',
    'resourceType': '리소스 유형',
    'resourceType_MENU': '메뉴',
    'resourceType_MODULE': '목차',
    'resourceType_WIDGET': '버튼',
    'resourceCode': '자원 인코딩',
    'resourceStatus': '자원 상태',
    'resourceStatus_true': '활성화',
    'resourceStatus_false': '비활성화',
    'resourceAddChildren': '새 하위',
    'resourceSuperior': '상위 메뉴',
    'icon': '아이콘 스타일',
    'iconActive': '활성 아이콘',
    'shortName': '약칭',
    'resourceUrl': '자원 URL',
    'resourceFun': '기능 URL',
    'openType': '열기 방법',
    'openType_0': '페이지 라우팅',
    'openType_1': '새 창',
    'pub': '권한 제어 필요 여부',
    'pub_true': '예',
    'pub_false': '아니오',
    'hidden': '숨김 여부',
    'hidden_0': '예',
    'hidden_1': '아니오',
    'selectSystem': '시스템을 먼저 선택하십시오.'
  },
  'protocol': {
    'num': '번호 지정',
    'protocolName': '계약 이름',
    'protocolNo': '계약 버전 번호',
    'signTime': '서명 시간',
    'remark': 'Remark',
    'signUser': '계정 서명',
    'signName': '고객 이름 서명',
    'signChild': '계약 하위 버전 번호'
  },
  'sfbuy': {
    'wechatScane': '위챗 좀 쓸어 주세요.',
    'wechatScane1': '제때에 파악하다',
    'wechatScane2': '위챗 동태',
    'onlineService': '온라인 고객 서비스',
    'aboutUs': '우리에 대해',
    'serviceGuide': '신입 가이드',
    'helpCenter': '도움말 센터',
    'serviceAndPrice': '서비스 및 가격',
    'announcement': '공지',
    'important': '중요'
  },
  weakPassword: {
    提示: '팁',
    账号异常提醒: '계정에 이상이 있습니다. 비밀번호를 변경하거나 인증 코드/QR 코드로 로그인하세요.',
    修改密码: '비밀번호 변경',
    关闭: '닫기',
    账号异常处理: '계정 이상 처리',
    绑定提示: '먼저 휴대폰 또는 이메일을 등록하고 비밀번호를 변경하세요',
    账号: '계정'
  },
  twoFactorAuth: {
    双因素认证: '이중 인증',
    认证方式: '인증 방식 ',
    为了您的账号安全: '귀하의 계정 보안을 위해, 이중 인증을 완료한 후 로그인해야 합니다.',
    请选择绑定: '바인딩을 선택해 주세요:',
    请先设置您的密码: '먼저 비밀번호를 설정하세요'
  },
  sendType: {
    您当前手机区号不支持whatsapp: '현재 휴대폰 지역 번호는 {noticeChanel}을 지원하지 않습니다. 다른 인증 코드 받기 방법을 선택하세요',
    请使用绑定手机号接收验证码: '등록된 휴대폰 번호로 인증 코드를 받으세요',
    请使用绑定邮箱接收验证码: '등록된 이메일로 인증 코드를 받으세요',
    请选择验证码接收方式: '인증 코드 수신 방법을 선택하세요'
  }
}
